<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card v-if="transactions">
                <v-card-title>
                  <div class="row">
                    <div class="col-md-4 primary" style="color: #FFF" v-if="transactions">
                      <!--<v-icon style="font-size: 22pt !important;margin-right: -10px" color="white">mdi-currency-usd</v-icon>-->
                      Montant total {{formatAmount(transactions.totalAmount.$numberDecimal )}} {{devise._code_alpha}}
                    </div>
                    <div class="col-md-8">
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="transactions.incomes"
                        :search="search"
                        sort-by="name"
                        class="elevation-1"
                        :loading="!transactions" loading-text="Chargement en cours...">

                  <template  v-slot:item._operation_ref="{ item }">
                    <router-link style="text-decoration: none"  :to="'/transactions/details/'+item._operation_ref">
                      {{item._operation_ref}}
                    </router-link>
                  </template>
                    <template  v-slot:item._old_amount="{ item }">
                        {{formatAmount(item._old_amount.$numberDecimal )}}
                    </template>
                    <template  v-slot:item._amount="{ item }">
                        {{formatAmount(item._amount.$numberDecimal )}}
                    </template>
                    <template  v-slot:item.total_amount="{ item }">
                    {{formatAmount((parseInt(item._old_amount.$numberDecimal) + parseInt(item._amount.$numberDecimal) ))}}
                  </template>
                  <template  v-slot:item._created_at="{ item }">
                    <a>{{getDate(item._created_at)}}</a>
                  </template>
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>
          <v-card v-else>
            <div class="col-md-12 text-center">
              {{$t('no_data')}}
            </div>
          </v-card>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */


    import helpers from "@/mixins/helpers";

    export default {
      label: "Transactions",
      mixins:[helpers(this)],
      props:['transactions','devise'],
        data() {
            return {
              search:'',
                headers: [
                    {
                        text: 'Montant initial',
                        align: 'start',
                        sortable: true,
                        value: '_old_amount',
                    },
                    {text: 'Montant réçu', value: '_amount'},
                    {text: 'Montant total', value: 'total_amount'},
                    {text: 'Reference', value: '_operation_ref'},
                    {text: 'Date', value: '_created_at'},

                ],
            }
        },
        computed: {},
        mounted() {},
        methods: {
        },

    }
</script>

<style scoped>
    .name_country_tab{
        margin-top: 3.3%;
        font-weight: bold;
    }
</style>
